<!-- 首页 -->
<template>
  <div class="pageLoading">
    <div class="loading_texture_top"> <img src="static/images/loading_texture_top.png" alt=""> </div>
    <div class="loading_title">第四届进博会汉高云展台</div>
    <div class="loading_logo"><img src="static/images/loading_logo.png" alt=""></div>
    <div class="loading_progress_wrap">
      <div class="loading_progress_outter">
        <div class="loading_progress_inner" :style="{ width: count ? count + '%' : '0%' }"></div>
      </div>
    </div>
    <div class="loading_note">加载中，请稍后…</div>
    <div class="loading_texture_bottom"> <img src="static/images/loading_texture_bottom.png" alt=""> </div>
  </div>
</template>

<script>

export default {
  name: 'Loading',
  props: {
    count: Number
  },
  data () {
    return {

    }
  },
  computed: {},

  created () {},

  mounted () {},

  methods: {}
}

</script>
<style scoped>
  .pageLoading {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-color: #f6f6f6;
    position: relative;
    /* background-color: #f60; */
  }
  .loading_title {
    font-size: 30px;
    font-weight: bold;
    color: #2a2d2f;
    text-align: center;
    position: absolute;
    top: 400px;
    left: 50%;
    transform: translateX(-50%);
  }
  .loading_texture_top {
    width: 100%;
    text-align: right;
    display: flex;
    justify-content: flex-end;
  }
  .loading_logo {
    text-align: center;
    margin-top: 105px;
  }
  .loading_logo img {
    width: 193px;
    display: block;
    margin: 0 auto;
  }
  .loading_texture_top img {
    width: 586px;
    height: 549px;
    /* display: block; */
    /* position: absolute; */
    /* right: 0; */
  }
  .loading_progress_wrap {
    width: 465px;
    height: 22px;
    margin: 0 auto;
    margin-top: 88px;
    border-radius: 10px;
    background-color: #e10010;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .loading_progress_outter {
    width: 450px;
    height: 12px;
    background-color: #b7000d;
    border-radius: 6px;
    overflow: hidden;
  }
  .loading_progress_inner {
    width: 50%;
    height: 100%;
    background-color: #ff0012;
    transition: all ease 0.2s;
  }
  .loading_note {
    text-align: center;
    font-size: 26px;
    color: #2a2d2f;
    margin-top: 30px;
  }
  .loading_texture_bottom img {
    width: 750px;
    height: 648px;
    /* position: absolute; */
    /* top: 812px; */
    /* bottom: 0; */
  }
</style>
